import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import cx from 'classnames';
import React from 'react';
export var FormLegend = function FormLegend(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$looksLike = _ref.looksLike,
      looksLike = _ref$looksLike === void 0 ? 'h5' : _ref$looksLike,
      rest = _objectWithoutProperties(_ref, ["children", "className", "looksLike"]);

  return React.createElement("legend", _objectSpread({
    className: cx(_defineProperty({}, "tds-text--".concat(looksLike), looksLike), className)
  }, rest), children);
};